// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';

export const ColorName = styled<any, Theme>('div')`
  color: ${props => props.theme.pdbCompare.color.titleColor};
  text-align: center;
`;

export const ColorPrice = styled<any, Theme>('div')`
  color: ${props => props.theme.pdbCompare.color.priceColor};
  font-size: .875rem;
  text-align: center;
`;
